import { createAppSlice } from 'app/createAppSlice'
import {
  createOrderStaff,
  getComodities,
  purchaseCommodityCheckUser,
  uploadFile,
} from './purchaseCommodityAction'
import moment from 'moment-timezone'

const variableState = {
  STEP: 'stepPO',
  ORDER_TYPE: 'orderType',
  SELLER: 'seller',
}

const initialState = {
  addItemCount: [1],
  isOpenModal: false,
  isOpenModalDraft: false,
  orders: {
    isLoading: false,
    step: parseInt(localStorage.getItem(variableState.STEP)) ?? 0,
    userId: null,
    item: [
      {
        orderItemId: 1,
        SKU: '',
        itemId: null,
        amount: '',
        imageUrl: '',
        nameItem: '',
        price: '',
        totalPrice: '',
        unit: {
          label: 'Kg',
          value: 'Kg',
        },
      },
    ],
    order: {
      type: localStorage.getItem(variableState.ORDER_TYPE) ?? "BUY",
      note: '',
      transaction_number: '',
      files: [],
    },
    buyer: null,
    seller: null,
    trxDate: moment(new Date()).format('YYYY-MM-DD'),
    project: null,
  },
  comodities: [],
}

export const purchaseCommoditySlice = createAppSlice({
  name: 'purchase/commodity',
  initialState,
  reducers: (create) => ({
    addItem: create.reducer((state) => {
      let count = state.addItemCount[state.addItemCount.length - 1] + 1

      state.orders.item = [
        ...state.orders.item,
        {
          orderItemId: count,
          SKU: '',
          amount: '',
          imageUrl: '',
          nameItem: '',
          price: '',
          totalPrice: '',
          unit: { label: 'Kg', value: 'Kg' },
        },
      ]

      state.addItemCount.push(count)
    }),
    setInitialSeller: create.reducer((state, { payload }) => {
      state.orders.seller = payload
    }),
    removeItem: create.reducer((state, { payload }) => {
      const filteredArr = state.addItemCount.filter((item) => item !== payload)

      state.orders.item = state.orders.item.filter(
        (item) => item.orderItemId !== payload,
      )
      state.addItemCount = filteredArr
    }),
    toggleModal: create.reducer((state) => {
      state.isOpenModal = !state.isOpenModal
    }),
    stepOrder: create.reducer((state, { payload }) => {
      state.orders.order.type = payload.type
      state.orders.step = payload.step

      localStorage.setItem(variableState.STEP, payload.step)
      localStorage.setItem(variableState.ORDER_TYPE, payload.type)
    }),
    setItemCount: create.reducer((state, { payload }) => {
      state.addItemCount = payload
    }),
    setOrders: create.reducer((state, { payload }) => {
      state.orders = payload
    }),
    setOrdersPayload: create.reducer((state, { payload }) => {
      state.orders.item = payload
    }),
    setTrxDate: create.reducer((state, { payload }) => {
      state.orders.trxDate = moment(payload).format('YYYY-MM-DD')
    }),
    setOrdersNote: create.reducer((state, { payload }) => {
      state.orders.order.note = payload ?? ''
    }),
    setOrdersCustomTrx: create.reducer((state, { payload }) => {
      state.orders.order.transaction_number = payload ?? ''
    }),
    setOrderBuyer: create.reducer((state, { payload }) => {
      state.orders.buyer = payload
      state.orders.userId = payload.userId
    }),
    setRemoveDoc: create.reducer((state, { payload }) => {
      const targetUrl = typeof payload === 'string' ? payload : payload?.url
      if (targetUrl) {
        state.orders.order.files = (state.orders.order.files || []).filter(
          (fileUrl) => fileUrl !== targetUrl,
        )
      } else if (
        typeof payload?.id === 'string' &&
        (payload.id.startsWith('http://') || payload.id.startsWith('https://'))
      ) {
        state.orders.order.files = (state.orders.order.files || []).filter(
          (fileUrl) => fileUrl !== payload.id,
        )
      } else if (typeof payload?.index === 'number') {
        state.orders.order.files = (state.orders.order.files || []).filter(
          (_, index) => index !== payload.index,
        )
      } else if (typeof payload?.id === 'number') {
        state.orders.order.files = (state.orders.order.files || []).filter(
          (_, index) => index !== payload.id,
        )
      }
    }),
    setInitStatePurchase: create.reducer((state) => {
      state.addItemCount = [1]
      state.isOpenModal = false
      state.orders = {
        isLoading: false,
        step: parseInt(localStorage.getItem(variableState.STEP)) ?? 0,
        userId: null,
        item: [
          {
            orderItemId: 1,
            SKU: '',
            itemId: null,
            amount: '',
            imageUrl: '',
            nameItem: '',
            price: '',
            totalPrice: '',
            unit: {
              label: 'Kg',
              value: 'Kg',
            },
          },
        ],
        order: {
          type: localStorage.getItem(variableState.ORDER_TYPE) ?? null,
          notes: '',
          transaction_number: '',
          files: [],
        },
        buyer: null,
        seller: null,
        trxDate: moment(new Date()).format('YYYY-MM-DD'),
        project: null,
      }
    }),
    setNewSeller: create.reducer((state, { payload }) => {
      let data = {
        fullName: payload.fullName,
        phoneNumber: payload.phoneNumber,
        bankCode: payload?.bankData?.code,
        bankName: payload?.bankData?.value,
        bankAccountName: payload.bankAccountName,
        bankAccountNumber: payload.bankAccountNumber,
        bankLogo: payload?.bankData?.logo,
        profileStatus: 'Belum Terverifikasi',
      }
      Object.assign(state.orders.seller, data)
    }),
    resetErrorMsg: create.reducer((state) => {
      state.errorMessage = ''
    }),
    toggleModalDraft: create.reducer((state) => {
      state.isOpenModalDraft = !state.isOpenModalDraft
    }),
    setProject: create.reducer((state, { payload }) => {
      state.orders.project = payload
    }),
  }),
  extraReducers: (builder) => {
    builder
      .addCase(purchaseCommodityCheckUser.pending, (state) => {
        state.orders.isLoading = true
      })
      .addCase(purchaseCommodityCheckUser.fulfilled, (state, { payload }) => {
        state.orders.isLoading = false

        let data = {
          fullName: payload.fullName,
          phoneNumber: payload.phoneNumber,
          bankCode: payload.bankCode,
          bankName: payload.bankName,
          bankAccountName: payload.bankAccountName,
          bankAccountNumber: payload.bankAccountNumber,
          bankLogo: payload.bankLogo,
          isLogin: payload.isLogin ?? false,
          profileImg: payload.profileImg,
          profileStatus: payload.profileStatus ?? payload.status,
          userId: payload.userId,
          ...payload,
        }
        state.orders.seller = data
      })
      .addCase(purchaseCommodityCheckUser.rejected, (state, { payload }) => {
        state.orders.isLoading = false
        state.errorMessage = payload
      })

      .addCase(createOrderStaff.pending, (state) => {
        state.orders.isLoading = true
      })
      .addCase(createOrderStaff.fulfilled, (state, { payload }) => {
        state.orders.isLoading = false
      })
      .addCase(createOrderStaff.rejected, (state, { payload }) => {
        state.orders.isLoading = false
      })
      .addCase(uploadFile.pending, (state) => {
        state.orders.isLoading = true
      })
      .addCase(uploadFile.fulfilled, (state, { payload }) => {
        state.orders.isLoading = false
        const uploadedUrl =
          payload?.url ||
          payload?.data?.url ||
          (typeof payload === 'string' ? payload : null)

        if (uploadedUrl && typeof uploadedUrl === 'string') {
          const currentFiles = state.orders.order.files || []
          if (!currentFiles.includes(uploadedUrl)) {
            state.orders.order.files = [...currentFiles, uploadedUrl]
          }
        }
      })
      .addCase(uploadFile.rejected, (state) => {
        state.orders.isLoading = false
      })
      .addCase(getComodities.fulfilled, (state, { payload }) => {
        state.comodities = payload
      })
  },
})

export const {
  addItem,
  removeItem,
  toggleModal,
  stepOrder,
  setOrdersPayload,
  setOrdersNote,
  setOrderBuyer,
  setRemoveDoc,
  setInitStatePurchase,
  setNewSeller,
  resetErrorMsg,
  setInitialSeller,
  setOrdersCustomTrx,
  setTrxDate,
  toggleModalDraft,
  setOrders,
  setItemCount,
  setProject,
} = purchaseCommoditySlice.actions

export default purchaseCommoditySlice.reducer
